import React, { useEffect, useState } from "react";
import {
  ButtonMob,
  instance,
  Loadingspinner,
} from "../../../utils/utils";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { ReactComponent as EditTag } from "../../../assets/elevva-pro-icons/edit-tag.svg";
import ConfirmDeletionModal from "../../Mob/components/modal-delete";
import { ReactComponent as SearchIconAlone } from "../../../assets/elevva-pro-icons/searchIconAlone.svg";
import Popover from "../../popover/popover";

const PRMembership = () => {
  const [modal, setModal] = useState(null);
  const [modalError, setModalError] = useState(null);
  const [logs, setLogs] = useState([]);
  const [loader, setLoader] = useState(false);

  const iconStyle = {
    cursor: "pointer",
    marginLeft: "0.5rem",
    color: "#9ca3af",
  };
  function getExercises() {
    setLoader(true);
    instance
      .get(`trainings/corp/exercises`)
      .then((res) => res.data)
      .then((data) => {
        data && data.length > 0 && setLogs(data);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoader(false));
  }
  const hideModal = () => {
    setModal(null);
  };
  function createNewRecord(event, state, record) {

    let name = event.target[0].value;
    let unit_measurement = event.target[1].value;
    let is_time_metric = event.target[2].checked;
    let is_inverse_metric = event.target[3].checked;

    let formData = new FormData();
    formData.append("name", name.trim());
    formData.append("summary", name.trim());
    formData.append("unit_measurement", is_time_metric ? ''  : unit_measurement.trim());
    formData.append("is_time_metric", is_time_metric);
    formData.append("is_inverse_metric", is_inverse_metric);
    if (state === "post") {
      instance
        .post(`trainings/corp/exercises/create`, formData)
        .then((res) => {
          if (res.data) {
            let styleModal = {
              display: "flex",
              position: "fixed",
              zIndex: 999,
              whiteSpace: "pre-line",
            };
            getExercises();
            setModal(
              <div
                className="popUpServices justify-content-center align-items-center"
                style={styleModal}
              >
                <div
                  className="modalInfoContenido"
                  style={{
                    background: "white",
                    borderRadius: "20px",
                    boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
                    padding: "2% 6%",
                  }}
                >
                  <div
                    className=""
                    style={{
                      position: "absolute",
                      top: "5%",
                      right: "1%",
                      fontWeight: "bold",
                      fontSize: "1.5rem",
                      color: " #9DACBD",
                      cursor: "pointer",
                    }}
                    onClick={() => setModal(null)}
                  >
                    <i className="bi bi-x-circle"></i>
                  </div>
                  <div
                    className=" mb-3 py-3"
                    style={{
                      lineHeight: "120%",
                      textAlign: "center",

                      minWidth: "calc(18rem + 1vmin)",

                      color: "var(--elevvabutonLogin_User)",
                    }}
                  >
                    <br />
                    El record se ha creado
                    <br />
                    <strong>correctamente.</strong>
                    <br />
                  </div>
                  <form id="form-password-change" onSubmit={hideModal}>
                    <div className="col-12">
                      <div className="col-12 btnAction_pruebas letraspopfi2">
                        <ButtonMob
                          colorButton={"var(--elevvabutonLogin_User)"}
                          text="Confirmar"
                          className={"mb-3 mt-3 dashboard-input"}
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            );
          }
        })
        .catch((err) => {
          let msg_error = err.response.data;
          if (msg_error.unit_measurement) {
            showError(msg_error.unit_measurement);
          } else {
            if (msg_error) {
              showError();
            }
          }
        });
    } else {
      instance
        .patch(`trainings/corp/exercises/${record.id}`, formData)
        .then((res) => {
          if (res.data) {
            let styleModal = {
              display: "flex",
              position: "fixed",
              zIndex: 999,
              whiteSpace: "pre-line",
            };
            getExercises();
            setModal(
              <div
                className="popUpServices justify-content-center align-items-center"
                style={styleModal}
              >
                <div
                  className="modalInfoContenido"
                  style={{
                    background: "white",
                    borderRadius: "20px",
                    boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
                    padding: "2% 6%",
                  }}
                >
                  <div
                    className=""
                    style={{
                      position: "absolute",
                      top: "5%",
                      right: "1%",
                      fontWeight: "bold",
                      fontSize: "1.5rem",
                      color: " #9DACBD",
                      cursor: "pointer",
                    }}
                    onClick={() => setModal(null)}
                  >
                    <i className="bi bi-x-circle"></i>
                  </div>
                  <div
                    className=" mb-3 py-3"
                    style={{
                      lineHeight: "120%",
                      textAlign: "center",

                      minWidth: "calc(18rem + 1vmin)",

                      color: "var(--elevvabutonLogin_User)",
                    }}
                  >
                    <br />
                    El record
                    <br />
                    <strong> sido editado</strong>
                    <br />
                    <strong>correctamente.</strong>
                    <br />
                  </div>
                  <form id="form-password-change" onSubmit={hideModal}>
                    <div className="col-12">
                      <div className="col-12 btnAction_pruebas letraspopfi2">
                        <ButtonMob
                          colorButton={"var(--elevvabutonLogin_User)"}
                          text="Confirmar"
                          className={"mb-3 mt-3 letraspopfi2actualizar"}
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            );
          }
        })
        .catch((err) => {
          let msg_error = err.response.data;
          if (msg_error.unit_measurement) {
            showError(msg_error.unit_measurement);
          } else {
            if (msg_error) {
              showError();
            }
          }
        });
    }

    event.preventDefault();
  }
  function createRecord() {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
    setModal(
      <div
        className="popUpServices justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "2% 6%",
          }}
        >
          <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "1%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModal(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div>
          <div
            className=" mb-3 py-3"
            style={{
              lineHeight: "100%",
              textAlign: "center",

              color: "var(--elevvabutonLogin_User)",
            }}
          >
            Nuevo <strong>Record</strong>
          </div>
            <form
                id="form-new-record"
                onSubmit={(e) => {
                    createNewRecord(e, "post");
                }}
                className="d-flex flex-column justify-content-center align-items-center gap-2"
            >
                <input
                    className="input-style-elevva dashboard-input my-1"
                    style={{
                        minWidth: "calc(18rem + 1vmin)",
                        fontSize: "calc(.3rem + .3vw)",
                    }}
                    name="descripcion"
                    placeholder="Describe nuevo record"
                    required
                />
                <input
                    className="input-style-elevva dashboard-input my-1"
                    style={{
                        minWidth: "calc(18rem + 1vmin)",
                        fontSize: "calc(.3rem + .3vw)",
                    }}
                    id="unidad"
                    name="unidad"
                    placeholder="Unidad de medida (Kg, reps, m/s)"
                    required
                />

                <div className="form-check">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="metricTime"
                        name="metricTime"
                        onChange={(e) => {
                            const unitInput = document.getElementById("unidad");
                            if (unitInput) {
                                unitInput.value = "Tmp";
                                unitInput.disabled = e.target.checked;
                                unitInput.required = !e.target.checked;
                            }
                        }}
                    />
                    <label
                        className="form-check-label"
                        htmlFor="metricTime"
                        style={{
                            color: "#394F65",
                            fontSize: "10px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                        }}
                    >
                        ¿Es una métrica de tiempo?
                    </label>
                </div>

                <div className="form-check">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="metricInversa"
                        name="metricInversa"
                    />
                    <label className="form-check-label" htmlFor="metricInversa" style={{
                        color: "#394F65",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "normal"
                    }}>
                        ¿Es una métrica inversa?
                        <Popover
                            title="¿Qué es una métrica inversa?"
                            description="En Elevva usamos métricas inversas cuando queremos que los valores más bajos sean los mejores dentro del ranking. Por ejemplo: en una prueba de tiempo, el usuario con menor tiempo ocupará el puesto"
                        >
                            <svg className="ms-1" width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8.5" cy="8.5" r="8.5" fill="#3177BE"/>
                                <path
                                    d="M8.68771 4.28522C9.89233 4.28522 11.0243 4.75355 11.8758 5.60505C12.7273 6.45655 13.1957 7.58855 13.1957 8.79317C13.1957 9.9978 12.7273 11.1298 11.8758 11.9813C11.0243 12.8328 9.89233 13.3011 8.68771 13.3011C7.48308 13.3011 6.35108 12.8328 5.49958 11.9813C4.64808 11.1298 4.17975 9.9978 4.17975 8.79317C4.17975 7.58855 4.64808 6.45655 5.49958 5.60505C6.35108 4.75355 7.48308 4.28522 8.68771 4.28522ZM8.68771 3.58398C5.81013 3.58398 3.47852 5.9156 3.47852 8.79317C3.47852 11.6707 5.81013 14.0024 8.68771 14.0024C11.5653 14.0024 13.8969 11.6707 13.8969 8.79317C13.8969 5.9156 11.5653 3.58398 8.68771 3.58398Z"
                                    fill="white"/>
                                <path
                                    d="M8.52797 5.64C8.90664 5.64 9.24264 5.696 9.53597 5.808C9.8293 5.92 10.0586 6.08533 10.224 6.304C10.3893 6.51733 10.472 6.78133 10.472 7.096C10.472 7.416 10.4026 7.68 10.264 7.888C10.1306 8.09067 9.9493 8.24533 9.71997 8.352C9.49064 8.45333 9.2373 8.52 8.95997 8.552L8.90397 9.304H7.90397L7.91197 8.096C8.2693 8.05333 8.54664 7.99733 8.74397 7.928C8.94664 7.85333 9.08797 7.76 9.16797 7.648C9.2533 7.536 9.29597 7.40267 9.29597 7.248C9.29597 7.09867 9.26397 6.97333 9.19997 6.872C9.1413 6.77067 9.05064 6.69333 8.92797 6.64C8.8053 6.58667 8.64797 6.56 8.45597 6.56C8.17864 6.56 7.9573 6.64 7.79197 6.8C7.62664 6.95467 7.5253 7.176 7.48797 7.464L6.44797 7.064C6.51197 6.78667 6.6293 6.54133 6.79997 6.328C6.97064 6.10933 7.1973 5.94133 7.47997 5.824C7.76797 5.70133 8.1173 5.64 8.52797 5.64ZM8.41597 9.84C8.62397 9.84 8.7893 9.896 8.91197 10.008C9.03464 10.12 9.09597 10.2693 9.09597 10.456C9.09597 10.648 9.03464 10.8 8.91197 10.912C8.7893 11.0187 8.62397 11.072 8.41597 11.072C8.20797 11.072 8.04264 11.0187 7.91997 10.912C7.7973 10.8 7.73597 10.648 7.73597 10.456C7.73597 10.2693 7.7973 10.12 7.91997 10.008C8.04264 9.896 8.20797 9.84 8.41597 9.84Z"
                                    fill="white"/>
                            </svg>
                        </Popover>
                    </label>
                </div>

                <div className="col-12">
                    <div className="col-12 btnAction_pruebas letraspopfi2">
                        <ButtonMob
                            colorButton={"var(--elevvabutonLogin_User)"}
                            text="Confirmar"
                            className={"my-2 dashboard-input"}
                        />
                    </div>
                </div>
            </form>
        </div>
      </div>
    );
  }
  function showError(errorMessage) {
    setModal(false);

    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
    setModalError(
      <div
        className="popUpServices justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "10%",
          }}
        >
          <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "1%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModalError(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div>
          <div
            className=" mb-3 py-3"
            style={{
              lineHeight: "100%",
              textAlign: "center",

              color: "var(--elevvabutonLogin_User)",
            }}
          >
            <div
              className=" pt-3 my-4"
              style={{
                lineHeight: "100%",
                textAlign: "center",

                color: "var(--elevvabutonLogin_User)",
              }}
            >
              {errorMessage ? (
                errorMessage
              ) : (
                <>
                  {" "}
                  Ha ocurrido un error
                  <strong> intenta de nuevo</strong>
                  <strong> más tarde</strong>
                </>
              )}
            </div>
            <ButtonMob
              handleClick={() => setModalError(null)}
              colorButton={"var(--elevvabutonLogin_User)"}
              text={"Continuar"}
              className={"mb-3 mt-3 letraspopfi2actualizar"}
            />
          </div>
        </div>
      </div>
    );
  }
  function showRecord(record) {
    console.log(record);
    setModal(
      <ConfirmDeletionModal
        onCancel={() => setModal(null)}
        onConfirm={() => setModal(null)}
        loader={false}
      >
        <h6>
          Detalles<strong className="mx-1">del PR</strong>
        </h6>
        <div className="table-container">
          <table className="min-w-full border border-gray-300 rounded-lg">
            <tbody>
              <tr className="bg-gray-100 text-left text-sm">
                <th className="p-2 border w-1/3">Nombre</th>
                <td className="p-2 border">{record.name}</td>
              </tr>
              <tr className="text-sm">
                <th className="p-2 border">Unidad de medida</th>
                <td className="p-2 border">{record.unit_measurement}</td>
              </tr>
              <tr className="text-sm">
                  <th className="p-2 border">Métrica de tiempo</th>
                  <td className="p-2 border">{record.is_time_metric ? "Si" : "No"}</td>
              </tr>
              <tr className="text-sm">
                  <th className="p-2 border">Métrica inversa</th>
                  <td className="p-2 border">{record.is_inverse_metric ? "Si" : "No"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ConfirmDeletionModal>
    );
  }

  function editRecord(record) {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
      console.log(record)

    setModal(
      <div
        className="popUpServices justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "2% 6%",
          }}
        >
          <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "1%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModal(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div>
          <div
            className=" mb-3 py-3"
            style={{
              lineHeight: "100%",
              textAlign: "center",

              color: "var(--elevvabutonLogin_User)",
            }}
          >
            Modificar <strong>Record</strong>
          </div>
          <form
            id="form-new-record"
            onSubmit={(e) => {
              createNewRecord(e, "patch", record);
            }}
            className="d-flex flex-column justify-content-center align-items-center gap-2"
          >
            <input
              className="input-style-elevva dashboard-input my-1"
              style={{
                minWidth: "calc(18rem + 1vmin)",
                fontSize: "calc(.3rem + .3vw)",
              }}
              defaultValue={record.name}
              name="tester"
              placeholder="Describe nuevo record"
              required
            />
            <input
              className="input-style-elevva dashboard-input my-1"
              style={{
                minWidth: "calc(18rem + 1vmin)",
                fontSize: "calc(.4rem + .4vw)",
              }}
              defaultValue={record.unit_measurement}
              name="tester"
              placeholder="Unidad de medida (Kg, reps, m/s)"
              required={!record.is_time_metric}
              disabled={record.is_time_metric}
            />
              <div className="form-check">
                  <input
                      className="form-check-input"
                      type="checkbox"
                      id="metricTime"
                      name="metricTime"
                      defaultChecked={record.is_time_metric}
                      onChange={(e) => {
                          const unitInput = document.getElementById("unidad");
                          if (unitInput) {
                              unitInput.value = "";
                              unitInput.disabled = e.target.checked;
                              unitInput.required = !e.target.checked;
                          }
                      }}
                  />
                  <label
                      className="form-check-label"
                      htmlFor="metricTime"
                      style={{
                          color: "#394F65",
                          fontSize: "10px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "normal",
                      }}
                  >
                      ¿Es una métrica de tiempo?
                  </label>
              </div>
            <div className="form-check">
              <input
                  type="checkbox"
                  className="form-check-input"
                  id="metricInversa"
                  name="metricInversa"
                  defaultChecked={record.is_inverse_metric}
              />
              <label className="form-check-label" htmlFor="metricInversa" style={{
                  color: "#394F65",
                  fontSize: "10px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal"
              }}>
                  ¿Es una métrica inversa?
                  <Popover
                      title="¿Qué es una métrica inversa?"
                      description="En Elevva usamos métricas inversas cuando queremos que los valores más bajos sean los mejores dentro del ranking. Por ejemplo: en una prueba de tiempo, el usuario con menor tiempo ocupará el puesto"
                  >
                      <svg className="ms-1" width="17" height="17" viewBox="0 0 17 17" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8.5" cy="8.5" r="8.5" fill="#3177BE"/>
                          <path
                              d="M8.68771 4.28522C9.89233 4.28522 11.0243 4.75355 11.8758 5.60505C12.7273 6.45655 13.1957 7.58855 13.1957 8.79317C13.1957 9.9978 12.7273 11.1298 11.8758 11.9813C11.0243 12.8328 9.89233 13.3011 8.68771 13.3011C7.48308 13.3011 6.35108 12.8328 5.49958 11.9813C4.64808 11.1298 4.17975 9.9978 4.17975 8.79317C4.17975 7.58855 4.64808 6.45655 5.49958 5.60505C6.35108 4.75355 7.48308 4.28522 8.68771 4.28522ZM8.68771 3.58398C5.81013 3.58398 3.47852 5.9156 3.47852 8.79317C3.47852 11.6707 5.81013 14.0024 8.68771 14.0024C11.5653 14.0024 13.8969 11.6707 13.8969 8.79317C13.8969 5.9156 11.5653 3.58398 8.68771 3.58398Z"
                              fill="white"/>
                          <path
                              d="M8.52797 5.64C8.90664 5.64 9.24264 5.696 9.53597 5.808C9.8293 5.92 10.0586 6.08533 10.224 6.304C10.3893 6.51733 10.472 6.78133 10.472 7.096C10.472 7.416 10.4026 7.68 10.264 7.888C10.1306 8.09067 9.9493 8.24533 9.71997 8.352C9.49064 8.45333 9.2373 8.52 8.95997 8.552L8.90397 9.304H7.90397L7.91197 8.096C8.2693 8.05333 8.54664 7.99733 8.74397 7.928C8.94664 7.85333 9.08797 7.76 9.16797 7.648C9.2533 7.536 9.29597 7.40267 9.29597 7.248C9.29597 7.09867 9.26397 6.97333 9.19997 6.872C9.1413 6.77067 9.05064 6.69333 8.92797 6.64C8.8053 6.58667 8.64797 6.56 8.45597 6.56C8.17864 6.56 7.9573 6.64 7.79197 6.8C7.62664 6.95467 7.5253 7.176 7.48797 7.464L6.44797 7.064C6.51197 6.78667 6.6293 6.54133 6.79997 6.328C6.97064 6.10933 7.1973 5.94133 7.47997 5.824C7.76797 5.70133 8.1173 5.64 8.52797 5.64ZM8.41597 9.84C8.62397 9.84 8.7893 9.896 8.91197 10.008C9.03464 10.12 9.09597 10.2693 9.09597 10.456C9.09597 10.648 9.03464 10.8 8.91197 10.912C8.7893 11.0187 8.62397 11.072 8.41597 11.072C8.20797 11.072 8.04264 11.0187 7.91997 10.912C7.7973 10.8 7.73597 10.648 7.73597 10.456C7.73597 10.2693 7.7973 10.12 7.91997 10.008C8.04264 9.896 8.20797 9.84 8.41597 9.84Z"
                              fill="white"/>
                      </svg>
                  </Popover>
              </label>
            </div>
              <div className="col-12">
                  <div className="col-12 btnAction_pruebas letraspopfi2">
                      <ButtonMob
                          colorButton={"var(--elevvabutonLogin_User)"}
                          text="Confirmar"
                          className={"my-2 dashboard-input"}
                      />
                  </div>
              </div>
          </form>
        </div>
      </div>
    );
  }
  function deleteAvailability(availability) {
    const handleDelete = () => {
      instance
        .delete(`trainings/corp/exercises/${availability.id}`)
        .then((res) => {
          if (res.status == "204" || res.status == "200") {
            setModal(
              <ConfirmDeletionModal
                onCancel={() => setModal(null)}
                onConfirm={() => setModal(null)}
                loader={false}
              >
                <br />
                Clase
                <br />
                <strong> eliminada</strong>
                <br />
                <strong>correctamente.</strong>
                <br />
              </ConfirmDeletionModal>
            );
          }
        })
        .catch((err) => {
          let msg_error = err.response.data;
          if (msg_error) {
            setModalError(
              <ConfirmDeletionModal
                onCancel={() => setModalError(null)}
                onConfirm={() => setModalError(null)}
                loader={false}
              >
                {msg_error.detail}
              </ConfirmDeletionModal>
            );
          }
        });
    };
    setModal(
      availability && (
        <ConfirmDeletionModal
          onCancel={() => setModal(null)}
          onConfirm={handleDelete}
          loader={false}
        >
          ¿Estás seguro de <br></br>
          <strong>eliminar {availability?.name || "la clase"}? </strong>
        </ConfirmDeletionModal>
      )
    );
  }
  useEffect(() => {
    getExercises();
  }, []);

  return (
    <div className="text-center h-100">
      {modal}
      {modalError}
      <div>
        <span
          style={{
            fontSize: "calc(0.4rem + 0.4vw)",
            color: "var(--elevvaTextTitle)",
          }}
        >
          <strong>Records del centro deportivo</strong>
        </span>
      </div>
      <div className="my-2">
        <button className="mx-auto d-flex ver_mas " onClick={createRecord}>
          Crear Récord
        </button>
      </div>
      <hr></hr>
      <div className=" w-100 p-2">
        <div
          className=" w-100"
          style={{
            border: "1px solid #B6C1CE",
            borderRadius: "10px",
          }}
        >
          {loader ? (
            <div
              className="px-2"
              style={{
                height: "calc(100vh - 60px - 11rem)",
                overflowY: "scroll",
                marginTop: "1rem",
              }}
            >
              <Loadingspinner size={"2.5rem"} />
            </div>
          ) : logs.length > 0 ? (
            <PerfectScrollbar
              className="px-2"
              style={{
                minHeight: "calc(100vh - 60px - 11rem)",
                maxHeight: "calc(100vh - 60px - 11rem)",
                overflowY: "scroll",
                marginTop: "1rem",
              }}
            >
              {logs.map((element, i) => (
                <div
                  key={i + "-log"}
                  className="d-flex justify-content-start align-items-center gap-3 px-3 py-3"
                  style={{
                    width: "100%",
                    borderBottom: "1px solid #B6C1CE",
                  }}
                >
                  <div className="d-flex align-items-center  justify-content-between w-100">
                    <div
                      className=" d-flex align-items-center justify-content-between "
                      style={{ width: "100%", textAlign: "left" }}
                    >
                      <span
                        style={{
                          fontSize: "calc(0.4rem + 0.4vw)",
                          display: "inline-block",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          fontWeight: "bold",
                          color: "var(--elevvaTextTitle)",
                          width: "60%",
                        }}
                      >
                        {element.name}
                      </span>
                      <span
                        style={{
                          fontSize: "calc(0.4rem + 0.4vw)",
                          textAlign: "left",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          fontWeight: "bold",
                          color: "var(--elevvaTextTitle)",
                          width: "40%",
                        }}
                      >
                        {element.is_time_metric ? 'Tiempo' : element.unit_measurement}
                      </span>
                    </div>

                    <div className="d-flex  align-items-center gap-2">
                      <span style={iconStyle}>
                        <SearchIconAlone onClick={() => showRecord(element)} />
                      </span>
                      <span style={iconStyle}>
                        <EditTag onClick={() => editRecord(element)} />
                      </span>
                      {/* <span style={iconStyle}>
                        <DeleteTag
                          onClick={(e) => deleteAvailability(element)}
                        />
                      </span> */}
                    </div>
                  </div>{" "}
                </div>
              ))}
            </PerfectScrollbar>
          ) : (
            <div
              style={{
                height: "calc(100vh - 60px - 11rem)",

                marginTop: "1rem",
              }}
            >
              No hay registros
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PRMembership;
